'use client';
// 商品 兌換按鈕

import useUserStore from '@/store/useUserStore';
import useModalStore from '@/store/useModalStore';

interface Props {
    item: any;
    isDisabled: boolean;
    buttonLabel: string;
}

const ItemExchangeButton = ({ item, isDisabled, buttonLabel }: Props) => {
    const { openModal } = useModalStore();

    const { user } = useUserStore();
    const { stardustCost = 0 } = item || {};

    const { balance = 0, uid } = user || {};

    // 兌換
    const onExchange = () => {
        if (!uid) return openModal('LOGIN');
        if (balance < stardustCost) return openModal('STARDUST_INSUFFICIENT');
        openModal('ITEM', { ...item, balance });
    };

    return (
        <div className="hidden lg:between-center">
            <p className="text-h1 text-vPurple">
                {stardustCost.toLocaleString()}&nbsp;
                <span className="text-h6 text-black9">星塵</span>
            </p>

            <button
                disabled={isDisabled}
                onClick={onExchange}
                className="text-[#fff] bg-vPurple text-btn1 round px-10 py-3 trans hover:bg-purple disabled:bg-black2"
            >
                {buttonLabel}
            </button>
        </div>
    );
};

export default ItemExchangeButton;
